




















import icoLookup from '@/utilities/ico-lookup'
import { pickBy } from 'lodash'
import A from '@/utilities/alpha'
import ExistingAssetPicker from './ExistingAssetPicker.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    ExistingAssetPicker
  }
})
export default class ConceptAssetLink extends Vue {
  @Prop({ required: true }) readonly linkAsset!: Record<string, db.Prototype>
  @Prop({ default: false }) readonly editable!: boolean
  @Prop({ default: () => ({}) }) readonly sharedLinks!: Record<string, db.Prototype>

  get urlIcon () {
    // Some assets are 'link-like' and we've been treating them as links here. But the icon doesn't have to be the generic link icon.
    if (['.pdf', '.doc', '.docx'].some(ext => this.assetValue.url?.endsWith(ext))) {
      return icoLookup.document
    }
    return icoLookup.url
  }

  get assetValue (): Partial<db.Prototype> {
    var keys = Object.keys(this.linkAsset)
    if (keys.length === 0) { return {} }
    return this.linkAsset[keys[0]]
  }

  get selectableLinks () {
    var that = this
    return pickBy(this.sharedLinks, function (sharedLink, ts) {
      return sharedLink.url !== that.assetValue.url
    })
  }

  updateAssetField (field: keyof db.Prototype, value: any) {
    var asset = A.clone(this.linkAsset)
    var key = Object.keys(asset)[0];
    (asset[key][field] as any) = value
    this.$emit('update', asset)
  }

  selectExistingAsset (asset: db.Prototype, ts: number) {
    var newAsset: Record<string, db.Prototype> = {}
    newAsset[ts] = A.clone(asset)
    this.$emit('update', newAsset)
  }
}
